// schema
import * as ISchema from "@schema";

import { timeSlots } from "@constants/time-slots.constant";

const pmStart = "T_12_00" as ISchema.TimeSlot; // FIXME: TEMP FIX FOR GQL2TS ISSUES
const pmStartIndex = timeSlots.all.findIndex((slot) => (slot as any) === pmStart);

export type SlotAndIndex = { slot: ISchema.TimeSlot; slotIndex: number };

function mergeRanges(
  sortedSlots: { slot: ISchema.TimeSlot; slotIndex: number }[],
): ISchema.TimeSlot[][] {
  const completedRanges: ISchema.TimeSlot[][] = [];
  let currentSlots: ISchema.TimeSlot[] = [];
  sortedSlots.forEach(({ slot, slotIndex }) => {
    // no current slots or we are contigous
    // FIXME: TEMP FIX FOR GQL2TS ISSUES
    if (
      currentSlots.length === 0 ||
      (currentSlots[currentSlots.length - 1] as any) === timeSlots.all[slotIndex - 1]
    ) {
      currentSlots.push(slot);
    } else {
      completedRanges.push(currentSlots);
      currentSlots = [slot];
    }
  });

  if (currentSlots.length !== 0) {
    completedRanges.push(currentSlots);
  }

  return completedRanges;
}

export function deserializeBitsToTimeSlots(bits: {
  amBits: number;
  pmBits: number;
}): SlotAndIndex[] {
  const enabledSlots: SlotAndIndex[] = [];

  timeSlots.all.forEach((slot, index) => {
    const isAm = index < pmStartIndex;
    const bitsToCheck = isAm ? bits.amBits : bits.pmBits;
    const slotOffset = isAm ? index : index - pmStartIndex;

    if (bitsToCheck & (1 << slotOffset)) {
      enabledSlots.push({ slot, slotIndex: index } as any); // FIXME: TEMP FIX FOR GQL2TS ISSUES
    }
  });

  return enabledSlots;
}

export function deserializeBits(
  date: string,
  bits: { amBits: number; pmBits: number },
): ISchema.IGapSlot[] {
  const enabledSlots = deserializeBitsToTimeSlots(bits);
  // NB: these slots are expected to be in sorted order
  const ranges = mergeRanges(enabledSlots);

  const gapSlots: ISchema.IGapSlot[] = ranges.map((range) => {
    const start = range[0];
    const size = range.length;

    return {
      __typename: "GapSlot" as "GapSlot",
      numSlots: size,
      dayTimeSlot: {
        date,
        __typename: "DayTimeSlot" as "DayTimeSlot",
        timeSlot: start,
      },
    };
  });

  return gapSlots;
}
